import { server } from '../config/server';

export const getEcsDetails = async (data) => {
  try {
    const url = `${server.apiURL}payments/getEcsDetails`;
    const options = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        credentials: 'include',
      },
      body: JSON.stringify(data),
      credentials: 'include',
    };
    const fetchResponse = await fetch(url, options);
    const response = await fetchResponse.json();
    const responseData = response;
    return responseData;
  } catch (e) {
    console.log('Error fetching getEcsDetails data');
    throw new Error(e.message || 'Error fetching getEcsDetails data');
  }
};
export const getEcsClearanceHistory = async (data) => {
  try {
    const url = `${server.apiURL}payments/getEcsClearanceHistory?pid=${data.pid}&city=${data.city}&shortUrl=${data.shortUrl}&docid=${data.docid}&projectId=${data.projectId}&mobile=${data.mobile}`;
    const fetchResponse = await fetch(url, { credentials: 'include' });
    const response = await fetchResponse.json();
    return response;
  } catch (e) {
    console.log('Error fetching getEcsClearanceHistory data');
    throw new Error(e.message || 'Error fetching getEcsClearanceHistory data');
  }
};

export const sendOtp = async () => {
  try {
    const url = `${server.apiURL}auth/sendOtp`;
    const options = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        credentials: 'include',
      },
      body: JSON.stringify({}),
      credentials: 'include',
    };
    const fetchResponse = await fetch(url, options);
    const response = await fetchResponse.json();
    return response;
  } catch (e) {
    console.log('Error fetching sendOtp data');
    throw new Error(e.message || 'Error fetching sendOtp data');
  }
};

export const verifyOtp = async (code) => {
  try {
    const url = `${server.apiURL}auth/verifyOtp`;
    const options = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        credentials: 'include',
      },
      body: JSON.stringify({
        vcode: code,
      }),
      credentials: 'include',
    };
    const fetchResponse = await fetch(url, options);
    const response = await fetchResponse.json();
    return response;
  } catch (e) {
    console.log('Error fetching verifyOtp data');
    throw new Error(e.message || 'Error fetching verifyOtp data');
  }
};
export const modifyEcs = async (reqbody) => {
  try {
    const url = `${server.apiURL}payments/modifyEcs `;
    const options = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        credentials: 'include',
      },
      credentials: 'include',
      body: JSON.stringify(reqbody),
    };
    const fetchResponse = await fetch(url, options);
    const response = await fetchResponse.json();

    return response;
  } catch (e) {
    console.log('Error fetching modifyEcs data');
    throw new Error(e.message || 'Error fetching modifyEcs data');
  }
};

export const updateEcs = async (reqbody) => {
  try {
    const url = `${server.apiURL}payments/updateEcs `;
    const options = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        credentials: 'include',
      },
      credentials: 'include',
      body: JSON.stringify(reqbody),
    };
    const fetchResponse = await fetch(url, options);
    const response = await fetchResponse.json();
    return response;
  } catch (e) {
    console.log('Error fetching updateEcs data');
    throw new Error(e.message || 'Error fetching updateEcs data');
  }
};
